const LOCAL_EXTERNAL_INSURER_LOGOS: Partial<Record<string, string>> = {
  'se-lansforsakringar': '/external-insurer-logos/se-lansforsakringar.png',
  'se-dina': '/external-insurer-logos/se-dina.png',
  'se-aktsam': '/external-insurer-logos/se-aktsam.png',
  'se-evoli': '/external-insurer-logos/se-evoli.png',
  'se-folksam': '/external-insurer-logos/se-folksam.webp',
  'se-swedbank': '/external-insurer-logos/se-swedbank.png',
  'se-trekronor': '/external-insurer-logos/se-tre-kronor.png',
  'se-watercircles': '/external-insurer-logos/se-watercircles.png',
}

const EXTERNAL_INSURER_WEBSITES: Partial<Record<string, string>> = {
  'se-aktsam': 'https://www.aktsam.se',
  'se-dina': 'https://www.dina.se',
  'se-evoli': 'https://www.evoli.se',
  'se-folksam': 'https://www.folksam.se',
  'se-gjensidige': 'https://www.gjensidige.se',
  'se-hedvig': 'https://www.hedvig.com',
  'se-ica': 'https://www.icaforsakring.se',
  'se-if': 'https://www.if.se',
  'se-lansforsakringar': 'https://www.lansforsakringar.se',
  'se-moderna': 'https://www.modernaforsakringar.se',
  'se-paydrive': 'https://www.paydrive.se',
  'se-svedea': 'https://www.svedea.se',
  'se-swedbank': 'https://www.swedbank.se',
  'se-trekronor': 'https://www.3kronor.se',
  'se-trygg-hansa': 'https://www.trygghansa.se',
  'se-volvia': 'https://www.volvia.se',
  'se-watercircles': 'https://www.watercircles.se',
}

function faviconUrl(websiteUrl: string) {
  const encodedURL = encodeURIComponent(websiteUrl)
  return `https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${encodedURL}&size=128`
}

export function getExternalInsurerLogoUrl(insurelyId: string | null | undefined): string | null {
  if (!insurelyId) return null

  const localPath = LOCAL_EXTERNAL_INSURER_LOGOS[insurelyId]
  if (localPath) return localPath

  const website = EXTERNAL_INSURER_WEBSITES[insurelyId]
  if (website) return faviconUrl(website)

  return null
}
